import React from 'react';
import { useDarkMode } from '../../../context/DarkModeContext';
import { ImageIcon, PlusIcon, DownloadIcon, EditIcon, TrashIcon, CalendarIcon, TypeIcon, LayoutIcon, ImagePlusIcon } from 'lucide-react';
import BackButton from '../../../components/UI/BackButton';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
import { useRoleTheme } from '../../../hooks/useRoleTheme';
const PromoGraphics = () => {
  const {
    darkMode
  } = useDarkMode();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const graphicTypes = [{
    id: 'teaser',
    title: 'Book Teaser',
    icon: ImageIcon,
    description: 'Highlight a quote or scene'
  }, {
    id: 'quote',
    title: 'Quote Card',
    icon: TypeIcon,
    description: 'Stylized text overlay'
  }, {
    id: 'character',
    title: 'Character Card',
    icon: LayoutIcon,
    description: 'Visual character profile'
  }, {
    id: 'banner',
    title: 'Series Banner',
    icon: ImagePlusIcon,
    description: 'Wide format for headers'
  }];
  const savedGraphics = [{
    id: 1,
    title: 'Silent Echo - Release Teaser',
    type: 'Book Teaser',
    date: 'Oct 24, 2023',
    image: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    id: 2,
    title: 'Character Reveal - Mira',
    type: 'Character Card',
    date: 'Oct 15, 2023',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    id: 3,
    title: 'Favorite Quote #2',
    type: 'Quote Card',
    date: 'Sep 30, 2023',
    image: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }];
  return <div className={`min-h-screen py-8 ${dk.page}`} data-id="element-19747" data-mp="4gg5p4xvyzzo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19748" data-mp="4hzn4yva3h31">
        <div className="mb-4" data-id="element-19749" data-mp="2y8xoeaz67eky">
          <BackButton data-id="element-19750" data-mp="2y9zarblmznhz" />
        </div>
        <h1 className={`text-3xl font-bold mb-8 ${dk.textHeading}`} data-id="element-19751" data-mp="3378zep17bv4r">
          Promotional Graphics
        </h1>

        {/* Create New Section */}
        <section className="mb-12" data-id="element-19752" data-mp="37819fkhwe423">
          <h2 className={`text-xl font-bold mb-4 flex items-center ${dk.textPrimary}`} data-id="element-19753" data-mp="376ztp2pxste1">
            <PlusIcon className={`h-5 w-5 mr-2 ${rt.textPrimary}`} data-id="element-19754" data-mp="3gymbjhws5qpr" />
            Create New Graphic
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-19755" data-mp="3lx7e3nzi8mhd">
            {graphicTypes.map(type => <button key={type.id} className={`p-6 rounded-xl border-2 border-dashed text-left transition-all group ${darkMode ? `border-gray-700 hover:border-${rt.accentColor}-500 hover:bg-gray-800` : `border-gray-300 hover:border-${rt.accentColor}-500 hover:bg-${rt.accentColor}-50`}`} data-id="element-19756" data-mp="3qy4vvzglreic">
                <div className={`h-10 w-10 rounded-lg flex items-center justify-center mb-3 ${darkMode ? 'bg-gray-800' : 'bg-gray-100'} group-hover:${rt.bgMedium}`} data-id="element-19757" data-mp="20m7c0d6xke8a">
                  <type.icon className={`h-6 w-6 ${dk.textFaint} group-hover:${rt.textPrimary}`} data-id="element-19758" data-mp="1o8bpab8s8cwi" />
                </div>
                <h3 className={`font-bold mb-1 ${dk.textPrimary}`} data-id="element-19759" data-mp="1farlaujjc2i7">
                  {type.title}
                </h3>
                <p className={`text-sm ${dk.textMuted}`} data-id="element-19760" data-mp="2byxwy1evjv5z">{type.description}</p>
              </button>)}
          </div>
        </section>

        {/* Saved Graphics Section */}
        <section data-id="element-19761" data-mp="22xhldqcbpn06">
          <h2 className={`text-xl font-bold mb-4 ${dk.textPrimary}`} data-id="element-19762" data-mp="2315ggtxf2hh0">
            Your Graphics
          </h2>
          {savedGraphics.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-19763" data-mp="rk5oy0iw86o1">
              {savedGraphics.map(graphic => <div key={graphic.id} className={`rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow border ${dk.card}`} data-id="element-19764" data-mp="mjhoko8rydh5">
                  <div className="relative aspect-video group" data-id="element-19765" data-mp="2f9s340tth6ti">
                    <img src={graphic.image} alt={graphic.title} className="w-full h-full object-cover" data-id="element-19766" data-mp="21hloij6bb7w6" />
                    <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2" data-id="element-19767" data-mp="2t7grvjr08y3u">
                      <button className="p-2 bg-white rounded-full text-gray-900 hover:bg-gray-100" data-id="element-19768" data-mp="2y4yyh3hjv18o">
                        <DownloadIcon className="h-5 w-5" data-id="element-19769" data-mp="2k9mv67pbw2g5" />
                      </button>
                      <button className="p-2 bg-white rounded-full text-gray-900 hover:bg-gray-100" data-id="element-19770" data-mp="2p8hnq1d3l5dg">
                        <EditIcon className="h-5 w-5" data-id="element-19771" data-mp="18u80xboi7ooq" />
                      </button>
                    </div>
                  </div>
                  <div className="p-4" data-id="element-19772" data-mp="159xuixi65coh">
                    <div className="flex justify-between items-start" data-id="element-19773" data-mp="158mn8npilmsm">
                      <div data-id="element-19774" data-mp="119dt3hqkbmwj">
                        <h3 className={`font-bold ${dk.textPrimary}`} data-id="element-19775" data-mp="1182ppj114h5y">
                          {graphic.title}
                        </h3>
                        <p className={`text-sm ${dk.textMuted}`} data-id="element-19776" data-mp="1a9an7yvq1dyz">
                          {graphic.type}
                        </p>
                      </div>
                      <button className={`${dk.textFaint} hover:text-red-500 transition-colors`} data-id="element-19777" data-mp="mjzk4aqwf7ho">
                        <TrashIcon className="h-4 w-4" data-id="element-19778" data-mp="w99exyd4n49h" />
                      </button>
                    </div>
                    <div className={`mt-3 flex items-center text-xs ${dk.textFaint}`} data-id="element-19779" data-mp="rij7mfl54rc5">
                      <CalendarIcon className="h-3 w-3 mr-1" data-id="element-19780" data-mp="3rnjbsfw8e9n" />
                      Created {graphic.date}
                    </div>
                  </div>
                </div>)}
            </div> : <div className={`text-center py-12 rounded-xl border-2 border-dashed ${dk.emptyState}`} data-id="element-19781" data-mp="1yuaex3b9kui7">
              <ImageIcon className={`h-12 w-12 mx-auto mb-4 ${dk.textFaint}`} data-id="element-19782" data-mp="28mg4k6e1mzu8" />
              <h3 className={`text-lg font-medium mb-2 ${dk.textHeading}`} data-id="element-19783" data-mp="2cns16vvc4lbx">
                No graphics yet
              </h3>
              <p className={dk.textMuted} data-id="element-19784" data-mp="1fy2c065q4vq2">
                Create your first promotional graphic above!
              </p>
            </div>}
        </section>
      </div>
    </div>;
};
export default PromoGraphics;